import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import { CardSchema } from './schema';
import type { CardBlockData } from './index';

interface CardBlockDataProps {
  data: CardBlockData;
  block: string;
  onChangeBlock: (id: string, data: CardBlockData) => void;
  [key: string]: any;
}

const CardBlockDataForm: React.FC<CardBlockDataProps> = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = CardSchema({ ...props, intl });

  const handleFieldChange = (id: string, value: any) => {
    onChangeBlock(block, {
      ...data,
      [id]: value,
    });
  };

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={handleFieldChange}
      formData={data}
      block={block}
    />
  );
};

export default CardBlockDataForm;
